var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCameraFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "ico-camera-a",
    points: "0 24 24 24 24 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ico-camera-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ico-camera-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.2197,11.47 L16.9027,11.787 C16.4517,9.49 14.4267,7.75 11.9997,7.75 C9.2427,7.75 6.9997,9.993 6.9997,12.75 C6.9997,15.507 9.2427,17.75 11.9997,17.75 C13.3357,17.75 14.5917,17.23 15.5347,16.285 C15.8277,15.992 15.8277,15.517 15.5347,15.225 C15.2407,14.932 14.7667,14.933 14.4747,15.225 C13.8147,15.886 12.9357,16.25 11.9997,16.25 C10.0707,16.25 8.4997,14.68 8.4997,12.75 C8.4997,10.821 10.0707,9.25 11.9997,9.25 C13.4677,9.25 14.7227,10.16 15.2407,11.444 C14.9477,11.185 14.5007,11.188 14.2197,11.47 C13.9267,11.763 13.9267,12.238 14.2197,12.531 L16.2497,14.561 L18.2807,12.531 C18.5737,12.238 18.5737,11.763 18.2807,11.47 C17.9877,11.177 17.5127,11.177 17.2197,11.47 L17.2197,11.47 Z M22.2497,18.2497 C22.2497,18.9397 21.6897,19.4997 20.9997,19.4997 L2.9997,19.4997 C2.3107,19.4997 1.7497,18.9397 1.7497,18.2497 L1.7497,7.7497 C1.7497,7.0607 2.3107,6.4997 2.9997,6.4997 L6.5927,6.4997 C6.8197,6.4997 7.0347,6.3967 7.1777,6.2197 L8.2837,4.8437 C8.3317,4.7837 8.4027,4.7497 8.4787,4.7497 L15.5207,4.7497 C15.5967,4.7497 15.6677,4.7837 15.7157,4.8437 L16.8237,6.2197 C16.9647,6.3967 17.1797,6.4997 17.4067,6.4997 L20.9997,6.4997 C21.6897,6.4997 22.2497,7.0607 22.2497,7.7497 L22.2497,18.2497 Z M20.9997,4.9997 L17.7667,4.9997 L16.8847,3.9037 C16.5507,3.4887 16.0537,3.2497 15.5207,3.2497 L8.4787,3.2497 C7.9467,3.2497 7.4497,3.4877 7.1157,3.9037 L6.2337,4.9997 L2.9997,4.9997 C1.4837,4.9997 0.2497,6.2337 0.2497,7.7497 L0.2497,18.2497 C0.2497,19.7667 1.4837,20.9997 2.9997,20.9997 L20.9997,20.9997 C22.5167,20.9997 23.7497,19.7667 23.7497,18.2497 L23.7497,7.7497 C23.7497,6.2337 22.5167,4.9997 20.9997,4.9997 L20.9997,4.9997 Z",
    mask: "url(#ico-camera-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCameraFlip);
export default __webpack_public_path__ + "static/media/Ico-camera-flip.c9171de2f1266a1776b46eb9b2e5627c.svg";
export { ForwardRef as ReactComponent };